/**
 * 消息管理 Mixin
 * 负责管理消息列表，提供消息的增删改查功能
 */
export default {
  data() {
    return {
      messages: [],
      currentMessageId: "",
      currentAnswer: "",
      relatedQuestions: [], // 相关问题数据（字符串数组）
    };
  },

  methods: {
    /**
     * 添加用户消息
     * @param {string} content - 消息内容
     * @param {boolean} isLoading - 是否为 loading 状态
     * @returns {object} 用户消息对象
     */
    addUserMessage(content, isLoading = false) {
      const userMessage = {
        content,
        time: new Date().toISOString(),
        sender: "me",
        avatar: "https://via.placeholder.com/40",
        isLoading: isLoading,
      };
      this.messages.push(userMessage);
      return userMessage;
    },

    /**
     * 更新用户消息
     * @param {object} message - 要更新的消息对象引用
     * @param {string} content - 新的消息内容
     * @param {boolean} isLoading - 是否为 loading 状态
     */
    updateUserMessage(message, content, isLoading = false) {
      if (message) {
        message.content = content;
        message.isLoading = isLoading;
      }
    },

    /**
     * 添加"思考中..."占位消息
     * @returns {object} 占位消息对象
     */
    addThinkingMessage() {
      const thinkingMessage = {
        content: "思考中...",
        time: new Date().toISOString(),
        sender: "others",
        avatar: "https://via.placeholder.com/40",
      };
      this.messages.push(thinkingMessage);
      return thinkingMessage;
    },

    /**
     * 移除"思考中..."占位消息
     */
    removeThinkingMessage() {
      const thinkingMessage = this.messages.find(
        (msg) => msg.sender === "others" && msg.content === "思考中..."
      );
      if (thinkingMessage) {
        const index = this.messages.indexOf(thinkingMessage);
        this.messages.splice(index, 1);
      }
    },

    /**
     * 添加 AI 消息
     * @param {object} messageData - 消息数据
     * @returns {object} AI 消息对象
     */
    addAIMessage(messageData) {
      const aiMessage = {
        id: messageData.message_id,
        content: "",
        displayedContent: "",
        time: new Date(messageData.created_at * 1000).toISOString(),
        sender: "other",
        avatar: "/static/ai-avatar.png",
        isStreaming: true,
      };

      // 移除思考中消息
      this.removeThinkingMessage();

      this.messages.push(aiMessage);
      this.currentMessageId = messageData.message_id;

      return aiMessage;
    },

    /**
     * 更新 AI 消息
     * @param {string} messageId - 消息ID
     * @param {object} updates - 更新内容
     */
    updateAIMessage(messageId, updates) {
      const aiMessage = this.findAIMessage(messageId);
      if (aiMessage) {
        Object.assign(aiMessage, updates);
      }
    },

    /**
     * 查找 AI 消息
     * @param {string} messageId - 消息ID
     * @returns {object|undefined} AI 消息对象
     */
    findAIMessage(messageId) {
      return this.messages.find(
        (msg) => msg.sender === "other" && msg.id === messageId
      );
    },

    /**
     * 添加错误消息
     * @param {string} errorText - 错误文本
     */
    addErrorMessage(errorText = "请求失败，请稍后重试") {
      this.removeThinkingMessage();

      const errorMessage = {
        content: errorText,
        time: new Date().toISOString(),
        sender: "others",
        avatar: "https://via.placeholder.com/40",
      };
      this.messages.push(errorMessage);
    },

    /**
     * 重置当前答案
     */
    resetCurrentAnswer() {
      this.currentAnswer = "";
      this.currentMessageId = "";
    },

    /**
     * 更新相关问题数据
     * @param {string[]} questions - 相关问题数组（字符串数组）
     */
    updateRelatedQuestions(questions) {
      if (Array.isArray(questions)) {
        this.relatedQuestions = questions;
      }
    },

    /**
     * 清空相关问题数据
     */
    clearRelatedQuestions() {
      this.relatedQuestions = [];
    },
  },
};
